import interrupt from "../interrupt.js";

export default function(name) {
  return this.each(function() {
    interrupt(this, name);
  });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/src/selection/interrupt.js
// module id = null
// module chunks = 